import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { PdfViewer } from "components/common/PdfViewer";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { JuniorActivateContact } from "./activateStep/JuniorActivateContact";
import { JuniorActivateDocuments } from "./activateStep/JuniorActivateDocuments";
import { JuniorActivateSigning } from "./activateStep/JuniorActivateSigning";
import { JuniorActivateTour } from "./activateStep/JuniorActivateTour";
import { JuniorActivationActivateUser } from "./activationStep/JuniorActivationActivateUser";
import { JuniorActivationActivateApp } from "./activationStep/JuniorActivationActivateApp";
import { JuniorActivationDownloadApp } from "./activationStep/JuniorActivationDownloadApp";
import { JuniorActivationScanCode } from "./activationStep/JuniorActivationScanCode";
import { JuniorDetail } from "./JuniorDetail";
import { JuniorOverview } from "./JuniorOverview";
import { JuniorRoutes } from "./JuniorRoutes";
import { JuniorStore } from "./JuniorStore";
import { StatusPage } from "./StatusPage";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class JuniorContainer extends React.Component<IProps> {
    store: JuniorStore;

    constructor(props: any) {
        super(props);
        this.store = new JuniorStore();
    }

    async componentDidMount() {
        try {
            const error = await this.store.loadData();
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("gJunior.page.title");
        return (
            <div>
                <Route
                    exact
                    path={JuniorRoutes.ROOT}
                    render={() =>
                        <JuniorOverview
                            store={this.store}
                        />
                    }
                />
                <Route exact path={JuniorRoutes.OVERVIEW} component={this.withStore(JuniorOverview)} />
                <Route exact path={JuniorRoutes.DETAIL} component={this.withStore(JuniorDetail)} />
                <Route exact path={JuniorRoutes.ACTIVATE_TOUR} component={this.withStore(JuniorActivateTour)} />
                <Route exact path={JuniorRoutes.ACTIVATE_SIGNING} component={this.withStore(JuniorActivateSigning)} />
                <Route exact path={JuniorRoutes.ACTIVATE_SUCCESS} component={this.withStore(StatusPage)} />
                <Route exact path={JuniorRoutes.ACTIVATE_ERROR} component={this.withStore(StatusPage)} />
                <Route exact path={JuniorRoutes.ACTIVATE_CONTACT} component={this.withStore(JuniorActivateContact)} />
                <Route exact path={JuniorRoutes.ACTIVATE_DOCUMENTS} component={this.withStore(JuniorActivateDocuments)} />
                <Route path={JuniorRoutes.PDF} component={() => <PdfViewer {...this.props} uint8Data={this.store.pdfData} />} />
                <Route exact path={JuniorRoutes.ACTIVATION_DOWNLOAD_APP} component={this.withStore(JuniorActivationDownloadApp)} />
                <Route exact path={JuniorRoutes.ACTIVATION_ACTIVATE_APP} component={this.withStore(JuniorActivationActivateApp)} />
                <Route exact path={JuniorRoutes.ACTIVATION_ACTIVATE_USER} component={this.withStore(JuniorActivationActivateUser)} />
                <Route exact path={JuniorRoutes.ACTIVATION_CODE} component={this.withStore(JuniorActivationScanCode)} />
                <Route exact path={JuniorRoutes.ACTIVATION_SUCCESS} component={this.withStore(StatusPage)} />
                <Route exact path={JuniorRoutes.ACTIVATION_ERROR} component={this.withStore(StatusPage)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/gJunior/JuniorContainer.tsx